import React from 'react';
import moment from 'moment';

import { Grid } from '@material-ui/core';
import { TextField, DateField, ImageField, Step } from '../SteppedForm';

import rules from './rules';

import './index.css';

const StepDriverdetails = (props) => {
  return (
    <Step
      id="driverdetails"
      title={props.getPersonalDetailsTitle('Driver Details')}
      skip={(formdata) =>
        props.getApplicant().owneroperator === false || formdata.onboardingFor === 'vehicle'
      }>
      <Grid container>
        <Grid item xs={12} lg={4}>
          <TextField
            id="driveraccred"
            label="Driver ID"
            valid={rules.numeric}
            help="If you are a 13cabs Professional Driver, your Driver ID is the number you use to log in to your MTI dispatcher."
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField id="driverpin" label="Driver PIN" valid={rules.numeric_fixed(4)} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DateField
            id="driveraccred_date"
            label="Driver Accreditation Expiry Date"
            maxDate={moment().add(10, 'years')}
            disablePast
          />
        </Grid>
        {props.stateconfig().driverstatecred && (
          <>
            <Grid item xs={12} lg={4}>
              <TextField
                id="driverstateaccred"
                label={props.stateconfig().driverstatecred + ' Number'}
                valid={rules.numeric}
                required
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <DateField
                id="driverstateaccred_date"
                label={props.stateconfig().driverstatecred + ' Expiry'}
                required
                disablePast
              />
            </Grid>
          </>
        )}
        <Grid container>
          <Grid
            item
            xs={12}
            lg={
              props.stateconfig().driverstatecred
                ? props.stateconfig().drivercredback
                  ? 4
                  : 6
                : props.stateconfig().drivercredback
                ? 6
                : 12
            }>
            <ImageField
              id="drivercred"
              label={
                '13cabs Driver Accreditation' +
                (props.stateconfig().drivercredback ? ' - Front' : '')
              }
              height={192}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
            />
          </Grid>
          {props.stateconfig().drivercredback ? (
            <Grid item xs={12} lg={props.inStates(['wa']) ? 4 : 6}>
              <ImageField
                id="drivercredback"
                label="Driver Accreditation - Back"
                height={192}
                width={128}
                min_filesize={1000}
                max_filesize={5242880}
              />
            </Grid>
          ) : (
            ''
          )}

          {props.stateconfig().driverstatecred ? (
            <Grid item xs={12} lg={props.stateconfig().drivercredback ? 4 : 6}>
              <ImageField
                id="driverstatecred"
                label={props.stateconfig().driverstatecred}
                height={192}
                width={128}
                min_filesize={1000}
                max_filesize={5242880}
              />
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepDriverdetails;
